const DriverOnboardingInfo1 = () => (
  <img
    src="/resources/images/driver-onboarding-info1.svg"
    alt="Driver onboarding"
    width={244}
    height={304}
    loading="lazy"
    data-testid="driverOnboardingInfo1"
  />
);

export default DriverOnboardingInfo1;
